import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const pregnancyWeekApi = createApi({
  reducerPath: 'pregnancyWeek',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes:['PregnancyWeek'],
  endpoints: (builder) => ({
    getAllWeekPregnancy: builder.query({
      query: () => 'accountSetup/weekOfPregnancyRanges',
      transformResponse: (res) => res.data,
      providesTags:['PregnancyWeek']
    }),
    addNewWeekPregnancy: builder.mutation({
      query: (data) => ({
        url: `accountSetup/weekOfPregnancyRanges`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags:['PregnancyWeek']
    }),
    updateWeekPregnancy: builder.mutation({
      query: ({ id, data }) => ({
        url: `accountSetup/weekOfPregnancyRanges/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: data,
      }),
      invalidatesTags:['PregnancyWeek']
    }),

    deleteWeekPregnancy: builder.mutation({
      query: (id) => ({
        url: `accountSetup/weekOfPregnancyRanges/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags:['PregnancyWeek']
    }),
  }),
});

export const {
  useGetAllWeekPregnancyQuery,
  useAddNewWeekPregnancyMutation,
  useUpdateWeekPregnancyMutation,
  useDeleteWeekPregnancyMutation,
} = pregnancyWeekApi;
